import type { TooltipItem } from 'chart.js'
import { formatCurrency } from '@sylveraio/react-utils'
import { type ChartType, TickFormat } from '../../types'

export function formatTooltipValue(
  value: TooltipItem<ChartType>['parsed']['y'],
  tickFormat?: TickFormat,
) {
  switch (tickFormat) {
    case TickFormat.CurrencyUSD:
      return formatCurrency(value, 2)
    case TickFormat.Default:
    default: {
      return value.toString()
    }
  }
}
